module.exports = __webpack_public_path__ + "static/img/img_bg_02.e41abee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_bg_02.jpg
// module id = 149
// module chunks = 1